import api from "./api";
import TokenService from "./token.service";

class AuthService {
  async login(user) {
    const response = await api
      .post('login', {
        email: user.email,
        password: user.password
      });
    if (response.data.status) {
      if (AuthService.rolCheck(response.data.token.original.user.role)){
        localStorage.setItem('user', JSON.stringify(response.data.token.original.user));
        localStorage.setItem('rol', JSON.stringify(response.data.token.original.user.role));
        localStorage.setItem('instituciones', JSON.stringify(response.data.token.original.user.instituciones));
        localStorage.setItem('access_token', JSON.parse(JSON.stringify(response.data.token.original.access_token)));
      }else {
        return false;
      }
    }
    return response.data;
  }

  logout() {
    TokenService.removeUser();
  }

  static rolCheck(roles) {
    return roles;
  }
}

export default new AuthService();